<portal-sub-nav route="enterprise-acd-queue">
  <div [class.d-none]="loading$ | async">
    @if (acdContext$ | async; as context) {
      <portal-menu-context
        [description]="context.queue.description"
        [heading]="'menu.context.acd' | portalTranslate"
      >
        <ng-template>
          <portal-acd-switcher [queue]="context.queue" [queues]="context.queues"></portal-acd-switcher>
        </ng-template>
      </portal-menu-context>
      <!-- Agents -->
      <portal-sub-nav-item [params]="{ queueId: context.queue.id }" route="enterprise-acd-queue-agents">
        <ng-template portalTransclude>
          <span>{{ 'menu.acdQueues.agents' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
      <!-- Assigned Numbers -->
      <portal-sub-nav-item
        [params]="{ queueId: context.queue.id }"
        route="enterprise-acd-queue-assigned-numbers"
      >
        <ng-template portalTransclude>
          <span>{{ 'menu.acdQueues.numbers' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
      <!-- Route Config -->
      <portal-sub-nav-item [params]="{ queueId: context.queue.id }" route="enterprise-acd-queue-route-config">
        <ng-template portalTransclude>
          <span>{{ 'menu.acdQueues.routing' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
      <!-- Settings -->
      <portal-sub-nav-item [params]="{ queueId: context.queue.id }" route="enterprise-acd-queue-settings">
        <ng-template portalTransclude>
          <span>{{ 'menu.acdQueues.settings' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
      <!-- Announcements -->
      <portal-sub-nav-item
        [params]="{ queueId: context.queue.id }"
        route="enterprise-acd-queue-announcements"
      >
        <ng-template portalTransclude>
          <span>{{ 'menu.acdQueues.announcements' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
      <!-- Voice Mail -->
      <portal-sub-nav-item [params]="{ queueId: context.queue.id }" route="enterprise-acd-queue-voice-mail">
        <ng-template portalTransclude>
          <span>{{ 'menu.acdQueues.voiceMail' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
      <!-- Call Recording -->
      @if (context.pcrAvailable === true || context.pcrEnabled === true) {
        <portal-sub-nav-item
          [params]="{ queueId: context.queue.id }"
          route="enterprise-acd-queue-call-recording"
        >
          <ng-template portalTransclude>
            <span>{{ 'menu.acdQueues.callRecording' | portalTranslate }}</span>
          </ng-template>
        </portal-sub-nav-item>
      }
      <!-- Call Log -->
      <portal-sub-nav-item [params]="{ queueId: context.queue.id }" route="enterprise-acd-queue-call-log">
        <ng-template portalTransclude>
          <span>{{ 'menu.acdQueues.callLog' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
      <!-- Contact Groups -->
      <portal-sub-nav-item
        [params]="{ queueId: context.queue.id }"
        route="enterprise-acd-queue-contact-groups"
      >
        <ng-template portalTransclude>
          <span>{{ 'menu.acdQueues.contactGroups' | portalTranslate }}</span>
        </ng-template>
      </portal-sub-nav-item>
    }
  </div>

  @if (loading$ | async) {
    <portal-menu-loading-indicator [withContext]="true"></portal-menu-loading-indicator>
  }
</portal-sub-nav>
